export interface WiringStep {
  from: string;
  to: string;
  text: string;
}

export const WIRING_STEPS: WiringStep[] = [
  { from: '电池 +', to: 'VCC 轨', text: '电池正极接 VCC 电源轨' },
  { from: '电池 −', to: 'GND 轨', text: '电池负极接 GND 地轨' },
  { from: 'VCC 轨', to: 'R1 / R2', text: 'R1、R2 一端接 VCC' },
  { from: 'R1 / R2', to: '输入 A / B', text: '上拉电阻另一端分别接输入 A、B' },
  { from: 'K1 / K2', to: 'GND 轨', text: '开关分别连接输入节点与 GND' },
  { from: '芯片 14 / 7', to: 'VCC / GND', text: '芯片 14脚接 VCC，7脚接 GND' },
  { from: '芯片 3脚 Y', to: 'R3', text: '输出脚 1Y 接 LED 限流电阻 R3' },
  { from: 'R3', to: 'LED 阴极', text: 'R3 接 LED 阴极侧' },
  { from: 'LED 阳极', to: 'VCC 轨', text: 'LED 阳极接 VCC，完成低电平点亮回路' }
];

export function validateConnection(step: WiringStep, first: string, second: string): boolean {
  return (first === step.from && second === step.to) || (first === step.to && second === step.from);
}
